import React from 'react';
import Hidden from '@mui/material/Hidden';
import logo from "./imgs/storelogo.png";

const Logo = ()=> {
    return (
        <React.Fragment>
            <Hidden lgDown implementation="js">
                <img src={logo} style={{marginRight:"0.5em"}} alt="ロゴ"/>
            </Hidden>
            <h1 style={{margin:"0",fontWeight:"normal",fontSize:"150%",display:"inline"}}>SideB</h1>
        </React.Fragment>
    )
}

export default Logo;